import invariant from 'invariant';

import { useEmbedSearchWidget } from '#/modules/embedSearchWidget/contexts/EmbedSearchWidgetContext';
import type { EmbedSearchWidgetLayoutHandleProps } from '#/modules/embedSearchWidget/layout/EmbedSearchWidgetLayoutHandleProps';
import type { embedSearchWidgetSearchVolopsRoute } from '#/modules/embedSearchWidget/volops/routing/embedSearchWidgetVolops.routes';
import { SearchVolopsRefinements } from '#/modules/search/volops/components/Refinements/SearchVolopsRefinements';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { EmbedSearchWidgetSearchVolopsPageLoadable } from './EmbedSearchWidgetSearchVolopsPageLoadable';

export const handle = {
  searchRefinements: <SearchVolopsRefinements includeSourcesFacet />,
  darkBackground: true,
  defaultSearchType: 'VOLOP',
  isSearchPage: true,
  searchFromPageType: 'SEARCH',
} satisfies EmbedSearchWidgetLayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof embedSearchWidgetSearchVolopsRoute>,
) {
  await EmbedSearchWidgetSearchVolopsPageLoadable.load();
}

export default function EmbedSearchWidgetSearchVolopsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { embedSearchWidget } = useEmbedSearchWidget();
  invariant(embedSearchWidget, 'Embed search widget not set.');

  return (
    <EmbedSearchWidgetSearchVolopsPageLoadable
      embedSearchWidget={embedSearchWidget}
    />
  );
}
